import React, { Component } from 'react'
import NoteItem from './item'

export default class NoteList extends Component {

  render () {

    const { notes } = this.props

    return (
      <div className="list-notes-container"> 
        { (notes) ? (
          notes.map((item, index) =>
            <NoteItem note={item} key={index} />  
          )) : ''
        }       
      </div> 
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Sections/Imi/Notes/list.js